import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FAQ_ITEM_DEFS, buildFaqHref } from '../../data/faqData';
import './FaqPageFooter.css';

export function FaqPageFooter() {
  const { t } = useTranslation();

  return (
    <footer className="saas-faq-foot">
      <p className="saas-faq-foot__meta">
        {t('faq.footerTopics', { count: FAQ_ITEM_DEFS.length })}
      </p>
      <p className="saas-faq-foot__hint">{t('faq.footerHint')}</p>
      <div className="saas-faq-foot__links">
        <Link to="/login" className="saas-faq-foot__link">
          {t('faq.loginCta')}
        </Link>
        <Link to={buildFaqHref({ id: 'saas-data-storage' })} className="saas-faq-foot__link">
          {t('faq.footerBackup')}
        </Link>
        <Link to="/" className="saas-faq-foot__link">
          {t('faq.footerProjects')}
        </Link>
      </div>
    </footer>
  );
}
